import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { set,setMulti, chargeAnalysisLanding } from '../../store/actions/pages';
import { createSelector } from 'reselect';

import ChargeAnalysisPageComponent from './ChargeAnalysisPage';

import { download, setClaimId } from '../../store/actions/chargeAnalysis';
import { setSelectedClaims } from '../../store/actions/claimAnalysis';
import { getByName, reset } from '../../store/actions/search';
import { selectDefaultCustomFilters } from '../../store/selectors/claimAnalysis';
import { selectSelectedClientName } from "../../store/selectors/clients";
import { tiny } from "../../store/actions/contracts";
import { list as getFacilities } from "../../store/actions/facilities";

const selectPending = createSelector(
        (state) => state.pages,
        (state) => state.search.getByName.pending,
        ( pages, searchPending) => {
            return pages['charge-analysis-landing'].pending || searchPending
        }
    );

export const ChargeAnalysisPage = connect(
    () => {
        return (state: any, props) => ({
            selectedClientName: selectSelectedClientName(state as never),
            defaultCustomFilters: selectDefaultCustomFilters(state, props),
            pending:selectPending(state),
            claimId: state.chargeAnalysis.claimId,
            pageState:state.pages['charge-analysis-landing'],
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            chargeAnalysisLanding: chargeAnalysisLanding,
            searchGetByName: getByName,
            searchReset: reset,
            setCustomFilter: (value) => set('charge-analysis-landing', 'customFilter', value),
            setFilter: (value) => set('charge-analysis-landing', 'filter', value),
            resetSearchCriteria: (value) => set('charge-analysis-landing', 'selectedFilter', value),
            resetPagedTable: () => set('charge-analysis-landing', 'list', []),
            resetCriteriaWaiting: () => set('charge-analysis-landing', 'waitForCriteriaFilter', false),
            resetSearchAPICompleted: () => set('charge-analysis-landing', 'isSearchApiCompleted', false),
            downloadAnalysisReport: download,
            setSelectedClaims: setSelectedClaims,
            setMulti: obj => setMulti("charge-analysis-landing", obj),
            getTinyContracts: tiny,
            getFacilities: getFacilities,
            setClaimId,
        }, dispatch)
    })
)(injectIntl(ChargeAnalysisPageComponent));